define([
	"dojo/_base/declare",
	"csi/heading/Enum"
], function(declare,Enum) {

	return declare(Enum, {
		isIcon: function(/*String*/enumId) {
			// summary: render
			return true;
		}
	});
});